import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';
import AccordionToggle from './AccordionToggle';

const styles = css`
  background-color: #fff;
  position: relative;
  font-family: ${typography.SansSerif};
  .FaqHeading{
    color: #571456;
    font-family: ${typography.SansSerif};
    font-weight: 800;
    letter-spacing: 6.18px;
    font-size:21px;
    text-align:center;
    text-transform: uppercase;
    &::after {
      content: '';
      width: 100px;
      height: 3px;
      position: relative;
      display: block;
      background-color: ${colors.color2};
      margin: 1em auto 2em auto;
    }
  }
  .Q_Body, .Q_Icon, .A_Body, .A_Icon{
    font-family: ${typography.SansSerif};
    font-size:20px;
    line-height:30px;
  }
  .A_Icon{
    background-color: ${colors.color4};
  }
  .Q_Icon{
    background-color: ${colors.color2};
  }
  .Q_Icon, .A_Icon{
    height:33px;
    width:33px;
    margin: 0px 30px;
    color:#fff;
    font-weight:900;
    text-align: center;
    border-radius: 100px;
    text-transform: uppercase;
  }
  .Q_Body{
    font:700 18px/24px ${typography.SansSerif};
    @media (min-width: 480px) {
      font:700 24px/30px ${typography.SansSerif};
    }
  }
  .A_Body{
    height: auto;
    margin-right:30px;
    color:#333;
    font:300 16px/20px ${typography.SansSerif};
    @media (min-width: 480px) {
      font:300 18px/36px ${typography.SansSerif};
    }
  }
  .Q_Arrow{
    height:0;
    width:0;
    border: solid 7px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: ${colors.color4};
    border-bottom-color:transparent;
    margin: 15px 30px 0px 30px;

  }
  .Q_Arrow_up{
    height:0;
    width:0;
    border: solid 7px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-color:${colors.color4};
    margin: 15px 30px 0px 30px;

  }
  .Q_Arrow_Open{
    background-image: url('Images/icon-triangle-red.svg');
  }
  .AccordionToggle_content {
    margin-bottom: 20px;
  }
  .AccordionToggle_button:focus {
    outline:none
  }
  .DetailSection_heading {
  color: ${colors.color5};
  padding: 20px;
  border-bottom: solid 2px ${colors.color3Darkest};
  font:300 16px/36px ${typography.SansSerif};
  outline: 0 !important;
  @media (min-width: 480px) {
    font:300 18px/36px ${typography.SansSerif};
  }
}
.DetailSection_body {
  border-top: transparent;
  padding:20px;
}
.ProcessList_Steps {
  color: ${colors.color2};
  font:700 20px/30px ${typography.SansSerif};
}
`;

function Process({ page }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-sm-10 mx-sm-auto AccordionWrapper DetailSection">
            <div id="description flex-column" />
            <ol className="ProcessList_Steps">
              {get(page, 'the_process', []).map(item => (
                <li>
                  <AccordionToggle
                    openOnId=""
                    button={({ contentVisible }) => (
                      <div className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>
                        <div className="row">
                          <div className="Q_Body col">
                            {get(item, 'header')}
                          </div>
                        </div>
                      </div>
                    )}
                  >
                    <div className="DetailSection_body pt-4 pb-5">
                      <div className="row">
                        <div className="A_Body col" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'description'))} />
                      </div>
                    </div>
                  </AccordionToggle>
                </li>
              ),
              )}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

Process.propTypes = {
  page: PropTypes.object.isRequired,
};

export default Process;



// WEBPACK FOOTER //
// ./src/pages/HomebuildingProcess/Process.js